import { render, staticRenderFns } from "./BlogContext.vue?vue&type=template&id=9924f8ea&"
import script from "./BlogContext.vue?vue&type=script&lang=js&"
export * from "./BlogContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports